// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoResults-cls1_YJH","cls2":"VideoResults-cls2_nMC VideoResults-cls1_YJH"};